(() => {
  'use strict';

  const SECTION_SELECTOR = '[data-mbb-box-content]';
  const REVEAL_SELECTOR = '[data-mbb-reveal]';
  const initialized = new WeakSet();

  function showAll(section) {
    section.querySelectorAll(REVEAL_SELECTOR).forEach((element) => {
      element.classList.add('is-visible');
    });
  }

  function initSection(section) {
    if (!section || initialized.has(section)) return;

    initialized.add(section);

    const elements = [...section.querySelectorAll(REVEAL_SELECTOR)];

    if (!elements.length) return;

    const reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      showAll(section);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -40px'
      }
    );

    elements.forEach((element, index) => {
      if (!element.style.getPropertyValue('--mbb-delay')) {
        element.style.setProperty('--mbb-delay', `${index * 80}ms`);
      }

      observer.observe(element);
    });
  }

  function initAll(scope = document) {
    if (scope.matches?.(SECTION_SELECTOR)) {
      initSection(scope);
    }

    scope
      .querySelectorAll?.(SECTION_SELECTOR)
      .forEach((section) => initSection(section));
  }

  function boot() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, {
      once: true
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    event.target
      .closest(REVEAL_SELECTOR)
      ?.classList.add('is-visible');
  });
})();